<template>
  <div>
    Display Salesforce Configuration Here...
  </div>
</template>

<script>
export default {
  name: 'SalesforceConfig',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
